import React from 'react';
import { IDT } from '@ff-os/pdp-shared-redux/IDT';
import classNames from 'classnames';
import { useExternalTotalRender } from '../../hooks/useExternalTotalRender';
import { PriceLabel } from '../price-label/PriceLabel';
import { OrderButton, OrderButtonProps } from './OrderButton';
import styles from './OrderButtonWithPriceLabel.module.scss';

export const OrderButtonWithPriceLabel = ({
    priceRequest, children, fullWidth, className, ...rest
}: Props) => {

    const classes = classNames(className, {
        [styles.fullWidth]: fullWidth
    });

    if (priceRequest.items.length === 0) {
        return (
            <OrderButton {...rest} className={classes}>
                {children}
            </OrderButton>
        );
    }

    return (
        <OrderButtonWithExternalPriceLabel
            {...rest}
            className={classes}
            contentClassName={styles.content}
            priceRequest={priceRequest}>
            {children}
        </OrderButtonWithExternalPriceLabel>
    );
};

const OrderButtonWithExternalPriceLabel = ({
    priceRequest, className, children, contentClassName, ...rest
}: Props) => {

    const { destinationRef, plainText } = useExternalTotalRender(priceRequest);

    return (
        <>
            <div ref={destinationRef} className={styles.buttonContainer}>
                {plainText ? (
                    <OrderButton {...rest}
                        contentClassName={classNames(contentClassName)}
                        className={classNames(className, 'idt-order-button--with-price')}
                        label={(
                            <PriceLabel className={styles.label} knockout>
                                {plainText}
                            </PriceLabel>
                        )}>
                        {children}
                    </OrderButton>
                ) : (
                    <OrderButton {...rest} className={className}>
                        {children}
                    </OrderButton>
                )}
            </div>
        </>
    );
};

type Props = OrderButtonProps & {
    fullWidth?: boolean;
    priceRequest: IDT.TotalPriceRequest;
};